export default {

	async page_list (params) {

		const [ companies, company_bans, transactions ] = await Promise.all([
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyBanList.fetch(),
			Anvil.models.TransactionList.fetch()
		])

		const search = new Anvil.models.Record({
			sort_order: params.sort_order || '',
			expression: params.expression || '',

			// Additional search parameters
			// ...
		})

		await Anvil.renderPage('/transaction/page_list', { companies, company_bans, transactions, search })
	},

	async action_refresh () {

		const [ companies, company_bans, transactions ] = await Promise.all([
			Anvil.models.CompanyList.fetch(),
			Anvil.models.CompanyBanList.fetch(),
			Anvil.models.TransactionList.fetch()
		])

		Anvil.page.companies = companies
		Anvil.page.company_bans = company_bans
		Anvil.page.transactions = transactions
		Anvil.models.components.Grid.find('#transaction_grid').list = transactions
	},

	async modal_import () {

		const form = new Anvil.models.Record({ file: null })

		await Anvil.modal('/transaction/modal_import', { form })
	},

	async action_import (files) {

		// Load the file into a base64 string
		if (!files || files.length == 0) {
			throw new Error('Nincs fájl kiválasztva az importáláshoz!')
		}

		for (let i = 0; i < files.length; i++) {

			Anvil.setSpinner('Fájlok importálása...', ((i + 1) / files.length * 100))

			const file = files[i]

			const base64 = await new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => resolve(reader.result.split(',')[1])
				reader.onerror = reject
				reader.readAsDataURL(file)
			})

			// Post the file to the server for import
			const res = await Anvil.REST.post('/transaction/import_xml', { file: base64 })
			if (res?.success !== true) {
				throw new Error('Az importálás sikertelen!')
			}
		}

		Anvil.page.modal.close()
		Anvil.page.refresh()
		Anvil.toast.success('Sikeres művelet', 'Az importálás sikeresen megtörtént!')
	},

	async modal_edit (uuid, direction) {

		const [ transaction ] = await Promise.all([
			Anvil.models.Transaction.fetch(uuid)
		])

		if (uuid == null) {
			transaction.direction = direction
			transaction.type = (direction == 'income') ? 'KÉSZPÉNZ BEFIZETÉS' : 'KÉSZPÉNZ KIFIZETÉS'
		}

		await Anvil.modal('/transaction/modal_edit', { transaction })
	},

	async action_save (transaction) {

		// Tell the record to commit
		const res = await transaction.record.commit()

		if (res === false) {
			throw new Error('A tranzakció mentése sikertelen! Kérjük, ellenőrizze a megadott adatokat.')
		}

		Anvil.toast.success('Elmentve', 'A tranzakció mentése sikeres')

		return true
	},

	async action_delete (uuid, confirm) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt tranzakciót?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('transaction/action_delete', uuid, true)
					}
				}
			})
			return
		}

		const res = await Anvil.models.Transaction.delete(uuid)
		if (res === false) {
			throw new Error('A tranzakció törlése sikertelen!')
		}

		Anvil.toast.success('Törölve', 'A tranzakció törlése sikeres')

		// Refresh list
		await this.action_refresh()
	}
}